import * as React from 'react';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { Opgave } from '../../models/Opgave';
import KonkurrenceOpgavePresenter from '../konkurrence/KonkurrenceOpgavePresenter';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { PrintButton } from '../../uiComponents/input/Buttons';

export interface OpgavePreviewProps {
    opgave: Opgave;
}

export default class OpgavePreview extends React.Component<OpgavePreviewProps, any> {

    render() {
        return (
            <PageWrapper>
                <PageTitle title={'Forhåndsvisning: ' + this.props.opgave.titel} />
                <ContentWrapper>
                    <PrintButton text='Udskriv' />
                    <KonkurrenceOpgavePresenter opgave={this.props.opgave} konkurrenceId={''} />
                </ContentWrapper>
            </PageWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgave/OpgavePreview.tsx